import { render } from "./VdbPlatformIcon.vue?vue&type=template&id=ca4a8308"
import script from "./VdbPlatformIcon.vue?vue&type=script&lang=js"
export * from "./VdbPlatformIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__